import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { RadioInput } from "../inputs/radio-input"

interface RadioFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof RadioInput>, "value" | "onChange" | "error"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
}

export function RadioField<T extends FieldValues>({ field, id, description, ...props }: RadioFieldProps<T>) {
  const { error } = useFormField()

  return (
    <FormItem>
      <FormControl>
        <RadioInput id={id} value={field.value} onChange={field.onChange} error={!!error} {...props} />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}

/* Example Usage:
interface FormData {
  plan: string;
}

<FormField
  control={form.control}
  name="plan"
  render={({ field }) => (
    <RadioField<FormData>
      field={field}
      id="plan"
      label="Subscription Plan"
      description="Choose your subscription plan"
      options={[
        { value: "free", label: "Free Plan" },
        { value: "pro", label: "Pro Plan" },
        { value: "enterprise", label: "Enterprise" },
      ]}
    />
  )}
/>
*/
